import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './AccessPage.css'; // Assuming the CSS is in this file
import backgroundImage from '../../Assets/Loginbackground.png'; // Import the background image

export default function Signup() {
  const [formData, setFormData] = useState({ FirstName: '', LastName: '', email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false); // For handling submission state
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.FirstName) newErrors.FirstName = 'First Name is required';
    if (!formData.LastName) newErrors.LastName = 'Last Name is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true); // Start submission process

    try {
      const response = await fetch(`${API_BASE_URL}/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        alert('User created successfully');
        navigate('/login'); // Navigate to login page after successful signup
      } else {
        alert(data.message || 'An error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('There was an issue with the signup. Please try again.');
    } finally {
      setIsSubmitting(false); // End submission process
    }
  };

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  return (
    <div className="container-split">
      <div className="image-half">
        <img src={backgroundImage} alt="Login Background" className="login-image" />
      </div>

      <div className="form-half">
        <div className="access-container1">
          <h2 className="access-title">SignUp</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="FirstName"
                value={formData.FirstName}
                onChange={handleChange}
                placeholder="Enter First Name"
                isInvalid={!!errors.FirstName}
              />
              <Form.Control.Feedback type="invalid">{errors.FirstName}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="LastName"
                value={formData.LastName}
                onChange={handleChange}
                placeholder="Enter Last Name"
                isInvalid={!!errors.LastName}
              />
              <Form.Control.Feedback type="invalid">{errors.LastName}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email Address"
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter Password"
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="button1"
              disabled={isSubmitting} // Disable button during submission
            >
              {isSubmitting ? 'Signing Up...' : 'Sign Up'}
            </Button>
          </Form>

          <div className="bottom mt-3">
            <p className="account">
              Already have an Account?{' '}
              <Button
                className="signuphyperlink"
                variant="link"
                onClick={handleLoginRedirect}
              >
                Login Here
              </Button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
